<div class="col-content show-display">
  <div class="header-content mb-xl-5 mb-3">
    <div class="heading">Ámbito geográfico del acuerdo</div>
    <div class="actions">
      <button *ngIf="canAccessCreateScope()" type="button"
        class="btn btn-primary" data-toggle="modal" data-target="#NuevoContact" (click)="openModalContact()">Nuevo Ámbito geográfico
      </button>
    </div>
  </div>
  <div class="container-form">
  <!-- Formulario de búsqueda -->
  <form class="container form-search py-3" [formGroup]="searchForm">
    <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="codigoLer">Codigo Ler</label>
          <div class="custom-mat-form-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="codigoLer" id="codigoLer" placeholder="-- Código LER y descripción de ENVALORA  --">
                <mat-option *ngFor="let cod of codigoLerArray" [value]="cod">
                  {{ cod.tipoCodigo }} {{ cod.descripcion }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="comunidad_autonoma">Comunidad Autónoma</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="comunidad_autonoma" id="comunidad_autonoma" placeholder="-- Comunidad --">
                <mat-option>
                  <ngx-mat-select-search [formControl]="searchControl" (searchChange)="filterComunidades($event)"
                  [placeholderLabel]="'Buscar'" [noEntriesFoundLabel]="' No se han encontrado resultados'">
                </ngx-mat-select-search>
              </mat-option>
                <mat-option *ngFor="let comunidad of filteredComunidades" [value]="comunidad">
                  {{ comunidad.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
    </div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
  <!-- FIN Formulario de búsqueda -->
</div>

  <div *ngIf="gridArray?.length !== 0 else messageClear"
    class="datatable-container table-responsive overflow-table table-detail-width-100">
    <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (actionButton)="action($event)"></lib-ge-table>
    <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
      <div class="d-flex mt-2" *ngIf="hasMultiplePages()">
        <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
          (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
        </ngb-pagination>
      </div>
      <div class="mt-2 selectPage" *ngIf="hasMultiplePages()">
        <label for="itemsPerPage">Mostrar:</label>
        <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
          <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
        </select>
      </div>
    </div>
  </div>
  <ng-template #messageClear>
    <div class="container-menu">
      <div class="mensaje-container">
        <p class="mensaje-linea">Sin información registrada</p>
      </div>
    </div>
  </ng-template>
</div>
